import { CommonEdition, Editions, IEditionInfo } from '@/base/platform/editions';
import { Params } from "react-router-dom";

export function getEditionFromParams(params: Readonly<Params<string>>): string {
    return params.edition || CommonEdition.key;
}

export function getEditionInfoFromParams(params: Readonly<Params<string>>): IEditionInfo {
    return Editions[params.edition || CommonEdition.key] || Editions['resident'];
}
